import { render, staticRenderFns } from "./Testpage.vue?vue&type=template&id=8edebd5e&scoped=true"
import script from "./Testpage.vue?vue&type=script&lang=js"
export * from "./Testpage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8edebd5e",
  null
  
)

export default component.exports